import type { AxSendFormulaPayload, PluginsAction } from '../types/Plugins';

const types = {
  AX_SEND_FORMULA: 'PLUGINS/AX_SEND_FORMULA',
} as const;

// const mountPath = 'plugins';

/*
 * action creators
 */

const actions = {
  axSendFormula: (
    params: AxSendFormulaPayload
  ): PluginsAction<AxSendFormulaPayload> => ({
    type: types.AX_SEND_FORMULA,
    payload: params,
  }),
};

export {
  types as actionTypes,
  actions as default,
  // propType,
  // selectors,
  // reducer,
};
